export const common = {
  "home.awards.title": "Auszeichnungen",
  "home.awards.pause": "Auszeichnungen pausieren",
  "home.awards.play": "Auszeichnungen abspielen",
  "home.awards.financialAlgorithm": "Führendes Unternehmen für Finanzalgorithmen",
  "home.awards.asiaPacificGold": "Führende Marke im Goldhandel in Asien und im Pazifikraum",
  "home.awards.preciousMetals": "Vertrauenswürdige Marke im Edelmetallhandel",
  "home.awards.digitalFinance": "Beitrag zur Innovation im digitalen Finanzwesen",
  "home.awards.quantitativeTrading": "Herausragendes Unternehmen für quantitative Handelstechnologie",
  // Navigation
  'nav.home': 'Startseite',
  'nav.trading': 'Handel',
  'nav.markets': 'Märkte',
  'nav.news': 'News',
  'nav.about': 'Über uns',
  'nav.contact': 'Kontakt',
  'nav.login': 'Anmelden',
  'nav.register': 'Registrieren',

  // Hero Section
  'hero.title': 'Premium-Plattform für den Handel mit Gold & Silber',
  'hero.subtitle': 'Lizensiertes Unternehmen aus Hongkong – sicheres, professionelles Trading mit Edelmetallen für europäische Anleger',
  'hero.cta.start': 'Jetzt handeln',
  'hero.cta.learn': 'Mehr erfahren',

  // Home
  'home.licenseHK': 'Lizensiert in Hongkong',
  'home.bankSec': 'Sicherheit auf Bankniveau',
  'home.247s': 'Support 24/7',
  'home.global': 'Globaler Fokus',
  'home.tradingPlat': 'Handelsplattform',
  'home.tradingWith': 'Handeln mit ',
  'home.exp': 'Erlebe die weltweit fortschrittlichste Trading-Plattform für Edelmetalle. MT5 bietet Tools in Institutionenqualität, blitzschnelle Ausführung und umfassende Marktanalysen.',
  'home.dlMT5': 'MT5 herunterladen',
  'home.watchDemo': 'Demo ansehen',
  'home.tradingIns': 'Handelsinstrumente',
  'home.exeSpeed': 'Ausführungsgeschwindigkeit',
  'home.mktAccess': 'Marktzugang',
  'home.uptime': 'Verfügbarkeit',
  'home.allDevices': 'Auf allen Geräten verfügbar',
  'home.mktInt': 'Market Intelligence',
  'home.mktInt.desc': 'Bleibe informiert mit Echtzeit-Wirtschaftsevents und Marktnachrichten, die den Edelmetallhandel beeinflussen',
  'home.lastUpdate': 'Zuletzt aktualisiert',
  'home.ecoCal': 'Wirtschaftskalender',
  'home.refresh': 'Aktualisieren',
  'home.currency': 'Währung',
  'home.events': 'Ereignisse',
  'home.previous': 'Vorheriger Wert',
  'home.forecast': 'Prognose',
  'home.actual': 'Aktuell',
  'home.mktNews': 'Marktnachrichten',
  'home.seeMore': 'Mehr anzeigen',
  'home.ecoData': 'Wirtschaftsdaten von mehreren Finanz-Datenanbietern • Marktnachrichten aus führenden Finanzpublikationen',
  'home.ac': 'Erweiterte Chartanalyse',
  'home.pta': 'Professionelle technische Analyse mit über 80 Indikatoren und Analyse-Tools',
  'home.mpa': 'Multi-Plattform-Zugang',
  'home.tsa': 'Nahtloses Trading auf Desktop, Web und Mobilgeräten',
  'home.st': 'Sicheres Trading',
  'home.bls': 'Sicherheit auf Bankniveau mit verschlüsselter Datenübertragung und -speicherung',
  'home.247': 'Marktzugang 24/7',
  'home.rtc': 'Rund-um-die-Uhr-Zugang zu globalen Edelmetallmärkten',
  'home.at': 'Automatisierter Handel',
  'home.ea': 'Expert Advisors (EAs) für algorithmische und automatisierte Strategien',
  'home.lfe': 'Blitzschnelle Ausführung',
  'home.ull': 'Orderausführung mit extrem niedriger Latenz und wettbewerbsfähigen Spreads',

  // Features
  'features.title': 'Warum unsere Plattform wählen',
  'features.security.title': 'Sicherheit auf Bankniveau',
  'features.security.desc': 'Fortschrittliche Verschlüsselung und mehrschichtige Sicherheitsprotokolle schützen deine Investitionen',
  'features.licensed.title': 'Voll lizensiert',
  'features.licensed.desc': 'Reguliertes Unternehmen in Hongkong mit voller Compliance und Transparenz',
  'features.realtime.title': 'Trading in Echtzeit',
  'features.realtime.desc': 'Live-Marktdaten und sofortige Ausführung für optimale Trading-Chancen',
  'features.support.title': 'Support 24/7',
  'features.support.desc': 'Professionelles, mehrsprachiges Support-Team rund um die Uhr verfügbar',
  'features.lmd': 'Live-Marktdaten',
  'features.rtp': 'Edelmetallpreise in Echtzeit',

  // Markets
  'markets.title': 'Live-Marktpreise',
  'markets.gold': 'Gold',
  'markets.silver': 'Silber',
  'markets.platinum': 'Platin',
  'markets.palladium': 'Palladium',
  'markets.price': 'Preis',
  'markets.change': 'Veränderung',
  'markets.high': '24h-Hoch',
  'markets.low': '24h-Tief',
  'markets.contractDetials': 'Kontraktdetails',
  'markets.contractDetials.desc': 'Umfassende Vertragsspezifikationen und Handelsbedingungen für Edelmetalle',
  'markets.tradingExample': 'Trading-Beispiel',
  'markets.goldExample': 'Gold-Trading-Beispiel',
  'markets.silverExample': 'Silber-Trading-Beispiel',
  'markets.instrument': 'Instrument',
  'markets.lotSize': 'Lot-Größe',
  'markets.entPrice': 'Einstiegskurs',
  'markets.marReq': 'Erforderliche Margin',
  'markets.pip': 'Pip-Wert',
  'markets.pmt': 'Handel mit Edelmetallen',
  'markets.ctt': 'Umfassende Handelsbedingungen, Konditionen und Spezifikationen für den Edelmetallhandel. Verstehe Kontraktdetails, Margin-Anforderungen und Risikomanagement für Gold- und Silber-Investments.',
  'markets.vts': 'Trading-Spezifikationen ansehen',
  'markets.dcd': 'Kontraktdetails herunterladen',
  'markets.ec': 'Ausführungsgeschwindigkeit',
  'markets.th': 'Handelszeiten',
  'markets.ms': 'Min. Spread (Pips)',
  'markets.ml': 'Max. Hebel',
  'markets.mr': 'Margin-Anforderungen',
  'markets.lo': 'Hebeloptionen und Margin-Anforderungen für verschiedene Kontotypen',
  'markets.leverage': 'Hebel',
  'markets.margin': 'Margin',
  'markets.mind': 'Mindest Einzahlung',
  'markets.mc': 'Margin-Rechner',
  'markets.gmc': 'Gold-Margin-Berechnung',
  'markets.cp': 'Aktueller Preis',
  'markets.cv': 'Kontraktwert',
  'markets.smc': 'Silber-Margin-Berechnung',
  'markets.rm': 'Risikomanagement',
  'markets.crm': 'Umfassende Tools und Strategien zum Schutz deiner Investitionen',
  'markets.rtg': 'Leitfaden zur Risikotoleranz',
  'markets.rd': 'Risikohinweis',
  'markets.tpm': 'Der Handel mit Edelmetallen ist mit erheblichen Verlustrisiken verbunden und nicht für alle Anleger geeignet. Vergangene Wertentwicklungen sind kein Indikator für zukünftige Ergebnisse.',
  'markets.lcw': 'Hebelwirkung kann sowohl für als auch gegen dich wirken. Prüfe vor einer Entscheidung deine Anlageziele, Erfahrung und Risikobereitschaft sorgfältig.',
  'markets.ysb': 'Sei dir aller Risiken des Edelmetallhandels bewusst und hole bei Zweifeln den Rat eines unabhängigen Finanzberaters ein.',
  'markets.rfr': 'Vollständigen Risikohinweis lesen',
  'markets.cra': 'Risikoberater kontaktieren',
  'markets.tho': 'Handelszeiten',
  'markets.moh': 'Marktöffnungszeiten und Feiertagskalender für den Edelmetallhandel',
  'markets.wts': 'Wöchentlicher Handelsplan',
  'markets.note': 'Hinweis',
  'markets.atad': 'Alle Zeiten in GMT+8. Der Handel kann an wichtigen Feiertagen und in Phasen hoher Volatilität ausgesetzt werden.',
  'markets.hs': 'Feiertagskalender',
  'markets.mclo': 'Markt geschlossen',
  'markets.eclo': 'Frühe Schließung',
  'markets.hn': 'Feiertagshinweis',
  'markets.thm': 'Handelszeiten können an nationalen Feiertagen angepasst werden. Bitte beachte unsere Ankündigungen.',
  'markets.cms': 'Aktueller Marktstatus',
  'markets.mac': 'Märkte sind derzeit OFFEN',
  'markets.st': 'Serverzeit (GMT+8)',
  'markets.ts': 'Handelsspezifikationen',
  'markets.dtc': 'Detaillierte Handelsbedingungen und Spezifikationen für Gold- und Silber-Instrumente',
  'markets.msp': 'Min. Spread',
  'markets.minls': 'Min. Lot-Größe',
  'markets.maxls': 'Max. Lot-Größe',
  'markets.commission': 'Provision',
  'markets.sls': 'Swap Long/Short',
  'markets.in': 'Wichtige Hinweise',
  'markets.smv': 'Spreads können sich bei hoher Volatilität und wichtigen Nachrichtenereignissen verändern',
  'markets.sra': 'Swap-Sätze werden täglich aktualisiert und können sich je nach Marktbedingungen ändern',
  'markets.mlm': 'Die maximale Hebelwirkung kann bei hochrelevanten News-Events reduziert werden',
  'markets.ata': 'Alle Zeiten werden in der Zeitzone GMT+8 angezeigt',

  // News
  'news.title': 'Aktuelle Marktnachrichten & Analysen',
  'news.subtitle': 'Bleibe mit Experteneinblicken und Markt-Updates auf dem Laufenden',
  'news.readMore': 'Mehr lesen',
  'news.category.analysis': 'Marktanalyse',
  'news.category.news': 'Eilmeldungen',
  'news.category.insights': 'Expert Insights',
  'news.category.education': 'Education',
  'news.date': 'Veröffentlicht',
  'news.author': 'Von',

  // Testimonials
  'home.partners.title': 'Unsere Partner',
  'home.partners.subtitle': 'Wir arbeiten mit führenden globalen Anbietern für Liquidität, Finanztechnologie und Handelsinfrastruktur zusammen.',
  'testimonials.title': 'Weltweit von Anlegern vertraut',
  'testimonials.client1.name': 'Marcus Weber',
  'testimonials.client1.location': 'Frankfurt, Deutschland',
  'testimonials.client1.text': 'Exzellente Plattform mit transparenter Preisgestaltung und zuverlässiger Ausführung. Die Sicherheitsfunktionen geben mir volles Vertrauen.',
  'testimonials.client2.name': 'Sophie Dubois',
  'testimonials.client2.location': 'Paris, Frankreich',
  'testimonials.client2.text': 'Professioneller Service und wettbewerbsfähige Spreads. Das mehrsprachige Support-Team ist äußerst hilfreich.',
  'testimonials.client3.name': 'Alessandro Rossi',
  'testimonials.client3.location': 'Mailand, Italien',
  'testimonials.client3.text': 'Schnelle Ausführung und hervorragende Werkzeuge für Marktanalysen. Sehr zu empfehlen für ernsthaften Edelmetallhandel.',

  // Footer
  'footer.company': 'Unternehmen',
  'footer.trading': 'Handel',
  'footer.support': 'Support',
  'footer.legal': 'Rechtliches',
  'footer.about': 'Über uns',
  'footer.careers': 'Karriere',
  'footer.news': 'News',
  'footer.platforms': 'Handelsplattformen',
  'footer.education': 'Education',
  'footer.analysis': 'Marktanalyse',
  'footer.help': 'Hilfe-Center',
  'footer.contact': 'Kontakt',
  'footer.faq': 'FAQ',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.privacy': 'Datenschutzerklärung',
  'footer.risk': 'Risikohinweis',
  'footer.copyright': '© 2024 GOLD Label Global Limited. Alle Rechte vorbehalten.',
  'footer.license': "In Hongkong eingetragenes Unternehmen",
  'footer.riskwarning': 'Risikowarnung',
  'footer.disclaimer': 'Margin-Trading ist ein gehebeltes Finanzprodukt und kann zu Verlusten führen, die deine Einlagen übersteigen. Du erwirbst oder hältst keine zugrunde liegenden Vermögenswerte. Bitte lies vor dem Handel sorgfältig unseren Risikohinweis. Stelle sicher, dass du die Risiken vollständig verstehst und deine Exponierung umsichtig verwaltest. Wir übernehmen keine Haftung für Handlungen oder Unterlassungen, die auf Basis der Informationen dieser Website erfolgen.',
  'footer.jurisdiction': "Hinweis zu den Rechtsordnungen",
  'footer.jurisdictionDisclaimer': "Die Dienstleistungen werden nur geeigneten Kunden in Rechtsordnungen außerhalb Hongkongs und der Vereinigten Staaten angeboten, sofern ihre Erbringung nach dem jeweils anwendbaren Recht am Wohnsitz des Kunden zulässig ist. Die Dienstleistungen werden nicht Einwohnern Hongkongs oder der Vereinigten Staaten und nicht Personen in Rechtsordnungen angeboten, in denen solche Dienstleistungen rechtswidrig oder verboten wären. Diese Website richtet sich nicht an Personen in beschränkten Rechtsordnungen und stellt dort kein Angebot, keine Aufforderung und keine Empfehlung dar.",
  'footer.relatedEntity': 'Weitere verbundene Gesellschaft',
  'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited ist eine am 4. September 2026 in Saint Lucia gegründete International Business Company mit der Registrierungsnummer 2026-00680. Eingetragener Sitz: Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia. Der eingetragene Sitz wird ausschließlich zur Erfüllung gesetzlicher und regulatorischer Anforderungen unterhalten. Er ist kein operativer Geschäftssitz des Unternehmens und wird nicht für den Geschäftsbetrieb, Kundenbesuche oder Korrespondenz genutzt.',
  'footer.regNo': 'Handelsregister-/Firmen-Nr.',

  // Common
  'common.language': 'Sprache',
  'common.loading': 'Wird geladen…',
  'common.error': 'Fehler',
  'common.success': 'Erfolg',
  'common.close': 'Schließen',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.continue': 'Fortfahren',
  'common.back': 'Zurück',
  'common.next': 'Weiter',
  'common.previous': 'Vorherige',
  'common.submit': 'Absenden',
  'common.reset': 'Zurücksetzen',

  // About
  'about.yearsOfExp': 'Jahre Erfahrung',
  'about.yearsOfExp.desc': 'Jahrzehntelange Expertise im Handel mit Edelmetallen',
  'about.dailyTrade': 'Tägliches Handelsvolumen',
  'about.dailyTrade.desc': 'Täglich 80 Mrd. HK$ an Gold- und Silbertransaktionen',
  'about.satClients': 'Zufriedene Kunden',
  'about.satClients.desc': 'Betreuung unzähliger Kunden und Institutionen weltweit',
  'about.exeSpeed': 'Ausführungsgeschwindigkeit',
  'about.exeSpeed.desc': 'Blitzschnelle Orderausführungstechnologie',
  'about.ourAch': 'Unsere Erfolge',
  'about.ourAch.desc': 'Anerkannte Exzellenz im Edelmetallhandel mit branchenführender Performance',
  'about.companyProfile': 'Unternehmensprofil',
  'about.about1': 'Über Gold Label Global',
  'about.about2': 'Gold Label Global Limited ist eine eingetragene Kapitalgesellschaft, von der Regierung Hongkongs genehmigt und Mitglied der Chinese Gold and Silver Exchange Society. In Hongkong werden täglich Gold- und Silbertransaktionen im Wert von 80 Mrd. HK$ abgewickelt – mit weltweit führender Erfahrung.',
  'about.about3': 'Das Managementteam von Gold Label Global verfügt über mehr als zwanzig Jahre fokussierte Erfahrung im Gold- und Silberhandel. Wir haben bereits unzählige Kunden und Institutionen betreut und Kundentransaktionen in zweistelliger Milliardenhöhe abgewickelt – mit höchstem Lob von Kunden und Branchenexperten.',
  'about.about4': 'Wir sind bestrebt, unseren Kunden schnelle, stabile und exzellente Handelsumgebungen zu bieten. Technisch setzen wir auf Handelssysteme auf internationalem Niveau und wählen erstklassige Technologiepartner, um leistungsfähigere und umfassendere Programme zu entwickeln – für schnellere, stabilere und vollständigere Ausführung.',
  'about.about5': 'Gold Label Global wird weiterhin gemeinsam mit Ihnen Gewinne schaffen und Wohlstand teilen.',
  'about.about6': 'Entdecken Sie unsere Reise im Edelmetallhandel und unser Engagement für Exzellenz auf den globalen Finanzmärkten.',
  'about.about7': 'Als eingetragene Kapitalgesellschaft, genehmigt von der Regierung Hongkongs und Mitglied der Chinese Gold & Silver Exchange Society, wickeln wir täglich Gold- und Silbertransaktionen im Wert von 80 Mrd. HK$ ab – führend in der Handelserfahrung.',
  'about.proTeam': 'Professionelles Team',
  'about.proTeam.desc': 'Unser Management verfügt über 20+ Jahre Erfahrung im Handel mit Gold und Silber und hat unzählige Kunden und Institutionen betreut.',
  'about.proService': 'Professioneller Service',
  'about.proService.desc': 'Professionelles Kundenteam mit 24-Stunden-Online- und Mobile-Support sowie gezielten Lösungen für Kundenprobleme.',
  'about.sec': 'Sicherheit zuerst',
  'about.sec.desc': 'Kein Gegenparteirisiko: Orders gehen direkt in den Markt – offen, transparent, sicher.',
  'about.strict': 'Strenge Aufsicht',
  'about.strict.desc': 'Gold Label Global ist ein kommerzieller Handelsplatz in Hongkong, reguliert von der Regierung Hongkongs und Mitglied der Hong Kong Commercial Trading Association.',
  'about.fastDes': 'Schnelle Einzahlung',
  'about.fastDes.desc': '24/7 Geschäftsabwicklung, Sekundeneinzahlung, sofortige Kontoeröffnung.',
  'about.productSafe': 'Produktsicherheit',
  'about.productSafe.desc': 'Abdeckung aller wichtigen globalen Edelmetallprodukte – sicher und zuverlässig.',
  'about.whyGLB': 'Warum Gold Label Global?',
  'about.whyGLB.desc': 'Entdecken Sie die Vorteile, die uns zur führenden Wahl für den Edelmetallhandel machen',
  'about.readyToStart': 'Bereit zu handeln?',
  'about.join': 'Schließen Sie sich tausenden zufriedenen Kunden an, die GOLD Label Global für ihren Edelmetallhandel vertrauen.',
  'about.openTradingAcc': 'Handelskonto eröffnen',
  'about.contactTeam': 'Unser Team kontaktieren',
  'about.co': 'Partnerschaft',
  'about.co.desc': 'Aufbau gegenseitig vorteilhafter Partnerschaften mit unseren Kunden und Stakeholdern',
  'about.safety': 'Sicherheit',
  'about.safety.desc': 'Höchstes Sicherheitsniveau für alle Handelsaktivitäten gewährleisten',
  'about.integrity': 'Integrität',
  'about.integrity.desc': 'Höchste Standards an Ehrlichkeit und Transparenz',
  'about.professional': 'Professionalität',
  'about.professional.desc': 'Erstklassige Dienstleistungen mit unvergleichlicher Professionalität',
  'about.fast': 'Schnelligkeit',
  'about.fast.desc': 'Schnelle Ausführung und reaktionsschneller Kundensupport',
  'about.coreValue': 'Unsere Grundwerte',
  'about.coreValue.desc': 'Die Prinzipien, die unser Streben nach Exzellenz im Edelmetallhandel leiten',

  // Contact
  'contact.sendUsMsg': 'Nachricht senden',
  'contact.fillOut': 'Füllen Sie das Formular aus – unser Team meldet sich innerhalb von 24 Stunden.',
  'contact.inqType': 'Anfrageart',
  'contact.genInq': 'Allgemeine Anfrage',
  'contact.accSup': 'Kontosupport',
  'contact.traSup': 'Trading-Support',
  'contact.techSup': 'Technischer Support',
  'contact.partner': 'Partnerschaft',
  'contact.fullname': 'Vollständiger Name *',
  'contact.email': 'E-Mail-Adresse *',
  'contact.phone': 'Telefonnummer',
  'contact.subject': 'Betreff *',
  'contact.msg': 'Nachricht *',
  'contact.sendMsg': 'Nachricht senden',
  'contact.whyUs': 'Warum wir?',
  'contact.regSec': 'Reguliert & sicher',
  'contact.licAndReg': 'Lizensierte und regulierte Handelsumgebung mit fortschrittlichen Sicherheitsmaßnahmen zum Schutz Ihrer Investitionen.',
  'contact.expSup': 'Experten-Support',
  'contact.proService': 'Professionelle Handelsspezialisten 24/7 – Unterstützung bei allen Fragen und Anliegen.',
  'contact.fastExe': 'Schnelle Ausführung',
  'contact.lightFast': 'Blitzschnelle Orderausführung mit minimalem Slippage für optimale Performance.',
  'contact.glbNet': 'Globale Märkte',
  'contact.asscessToint': 'Zugang zu internationalen Edelmetallmärkten mit wettbewerbsfähigen Spreads und hoher Liquidität.',
  'contact.followUs': 'Folgen Sie uns in den sozialen Medien:',
  'contact.contactOutPro': 'Kontaktieren Sie unser professionelles Team für Trading-Support, Konto-Hilfe oder allgemeine Anfragen:',
  'contact.officeAddress': 'Geschäftsanschrift',
  'contact.bussHour': 'Geschäftszeiten: Mo–Fr 9:00–18:00 (GMT+8)',
  'contact.phoneSupp': 'Telefonischer Support',
  'contact.mainOffice': 'Hauptsitz',
  'contact.availableServices': 'Verfügbare Dienstleistungen:',
  'contact.accOpenSup': 'Unterstützung bei der Kontoeröffnung',
  'contact.tradSup': 'Hilfe zur Handelsplattform',
  'contact.genSup': 'Allgemeiner Support',
  'contact.emailSup': 'E-Mail-Support',
  'contact.responseTime': 'Reaktionszeit:',
  'contact.genInq24': 'Allgemeine Anfragen: innerhalb von 24 Stunden',
  'contact.techSup24': 'Technischer Support: innerhalb von 4 Stunden',
  'contact.accIss24': 'Kontoangelegenheiten: innerhalb von 2 Stunden',
  'contact.needImSup': 'Soforthilfe benötigt?',
  'contact.needImSup.desc': 'Unsere Handelsspezialisten stehen rund um die Uhr für dringende Handelsfragen und Kontosupport bereit.',
  'contact.callNow': 'Jetzt anrufen',
  'contact.sendEmail': 'E-Mail senden',
  'contact.contactUs': 'Kontakt aufnehmen',
  'contact.getInTouch': 'Nehmen Sie Kontakt zu unserem professionellen Handelsteam auf. Wir helfen Ihnen, im Edelmetallhandel erfolgreich zu sein.',
  'contact.247Sup': 'Support 24/7',
  'contact.247Sup.desc': 'Rund-um-die-Uhr-Kundenservice für all Ihre Handelsbedürfnisse',
  'contact.dirLine': 'Direktdurchwahl',
  'contact.dirLine.desc': 'Sprechen Sie direkt mit unseren Handelsspezialisten',
  'contact.hkOffice': 'Büro Hongkong',
  'contact.hkOffice.desc': 'Im Herzen des Finanzdistrikts von Hongkong gelegen',

  // Platform
  'platform.wco': 'Warum unsere MT5-Plattform?',
  'platform.etd': 'Erleben Sie den Unterschied mit unserer Premium-Handelsplattform für anspruchsvolle Trader',
  'platform.rts': 'Bereit zu handeln?',
  'platform.jto': 'Schließen Sie sich tausenden Tradern an, die unserer Plattform für den Edelmetallhandel vertrauen',
  'platform.ola': 'Live-Konto eröffnen',
  'platform.tda': 'Demokonto testen',
  'platform.dmt': 'MT5-Plattform herunterladen',
  'platform.ayt': 'Greifen Sie mit unseren Multi-Plattform-MT5-Apps von jedem Gerät auf Ihr Handelskonto zu',
  'platform.free': 'Kostenlos',
  'platform.dn': 'Jetzt herunterladen',
  'platform.sr': 'Systemanforderungen',
  'platform.nh': 'Hilfe beim Start?',
  'platform.os': 'Unser Support hilft Ihnen bei Einrichtung und Start',
  'platform.ug': 'Benutzerhandbuch',
  'platform.cs': 'Support kontaktieren',
  'platform.si': 'Stabile Internetverbindung erforderlich',
  'platform.ptf': 'Leistungsstarke Handelsfunktionen',
  'platform.epg': 'Professionelle Tools für Einsteiger und Experten',
  'platform.ac': 'Erweiterte Charts',
  'platform.pct': 'Professionelle Charting-Tools mit 80+ Indikatoren und mehreren Zeitrahmen für umfassende Analysen.',
  'platform.lfe': 'Blitzschnelle Ausführung',
  'platform.ull': 'Handel mit extrem niedriger Latenz – Ausführung ab 0,01 Sekunden für optimale Einstiege und Ausstiege.',
  'platform.ea': 'Expert Advisors (EAs)',
  'platform.atc': 'Automatisiertes Trading mit eigenen EAs und algorithmischen Strategien',
  'platform.rm': 'Risikomanagement',
  'platform.crm': 'Umfassende Tools: Stop-Loss, Take-Profit und Positionsgrößensteuerung',
  'platform.mpa': 'Multi-Plattform-Zugang',
  'platform.tsa': 'Nahtlos handeln auf Desktop, Web und Mobile mit synchronisiertem Konto',
  'platform.gm': 'Globale Märkte',
  'platform.ati': 'Zugang zu internationalen Märkten: Edelmetalle, Forex, Indizes, Rohstoffe',
  'platform.etw': 'Erleben Sie die weltweit fortschrittlichste Handelsplattform. Handeln Sie Edelmetalle, Forex und CFDs mit Technologie auf Institutionsniveau und blitzschneller Ausführung.',
  'platform.download': 'Herunterladen ',
  'platform.wd': 'Demo ansehen',
  'platform.es': 'Ausführungsgeschwindigkeit',
  'platform.th': 'Handelszeiten',
  'platform.in': 'Instrumente',
  'platform.lt': 'Live-Trading',
  'platform.ptt': 'Professionelle Handelstools',
  'platform.aig': 'Zugang zu Tools auf Institutionsniveau – für Pros und ernsthafte Anleger',
  'platform.rtd': 'Echtzeitdaten',
  'platform.lmd': 'Live-Marktdaten und sofortige Preisaktualisierungen',
  'platform.pa': 'Preisalarme',
  'platform.caf': 'Individuelle Alarme für Preisbewegungen und Events',
  'platform.this': 'Handelshistorie',
  'platform.cth': 'Umfassende Historie und Performance-Analysen',
  'platform.ec': 'Wirtschaftskalender',
  'platform.suw': 'Bleiben Sie bei wichtigen Wirtschaftsereignissen auf dem Laufenden',
  'platform.mw': 'Market Watch',
  'platform.rtp': 'Echtzeit-Quotes und Markttiefe für alle Instrumente',
  'platform.om': 'Ordermanagement',
  'platform.aot': 'Erweiterte Ordertypen: Market, Limit, Stop, Trailing-Stop',
  'platform.ta': 'Technische Analyse',
  'platform.cta': 'Umfassende Analyse-Tools mit Custom-Indikatoren und Zeichenwerkzeugen',
  'platform.ufe': 'Ultra-schnelle Ausführung',
  'platform.rtc': 'Rund-um-die-Uhr-Support durch Trading-Experten und Technikspezialisten',
  'platform.247a': 'Rund um die Uhr verfügbar',
  'platform.csp': 'Wettbewerbsfähige Spreads',
  'platform.iia': 'Branchenführende Spreads und transparente Preise – ohne versteckte Gebühren oder Kommissionen',
  'platform.01pip': 'Ab 0,1 Pips',
  'platform.ffd': 'Vollwertige Desktop-App für Windows 10/11',
  'platform.nma': 'Native macOS-App mit voller Funktionalität',
  'platform.mta': 'Mobile Trading-App für Android',
  'platform.iai': 'iPhone- und iPad-Trading-App',

  // FAQ SECTION
  'faq.tagline': 'WIE KÖNNEN WIR HELFEN?',
  'faq.title': 'Wie können wir helfen?',
  'faq.subtitle': 'Durchstöbern Sie unsere umfassenden FAQ-Bereiche, um schnelle Antworten zu finden',
  'faq.categories': 'Kategorien',

  // Footer help box
  'faq.cantFind': 'Nicht gefunden, was Sie suchen?',
  'faq.supportText': 'Unser Support hilft gern bei allen Fragen, die in den FAQs nicht abgedeckt sind.',
  'faq.contactSupport': 'Support-Team kontaktieren',

  // Category titles
  'faq.general': 'Allgemein',
  'faq.account': 'Konto',
  'faq.trading': 'Trading',
  'faq.platform': 'Plattform',
  'faq.deposits': 'Ein- & Auszahlungen',
  'faq.security': 'Sicherheit',

  // General
  'faq.general.q1': 'Was ist GOLD LABEL GLOBAL LIMITED?',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED ist ein reguliertes Edelmetall-Handelsunternehmen mit Sitz in Hongkong und bietet professionelle Handelsdienste für Gold, Silber und andere Edelmetalle über die MT5-Plattform.',
  'faq.general.q2': 'Welche Handelsinstrumente bieten Sie an?',
  'faq.general.a2': 'Wir bieten ein umfassendes Spektrum an Edelmetallen, darunter Spot-Gold (XAU/USD), Spot-Silber (XAG/USD), Platin, Palladium sowie diverse Edelmetall-Futures.',
  'faq.general.q3': 'Wie sind Ihre Handelszeiten?',
  'faq.general.a3': 'Unsere Edelmetallmärkte sind 24 Stunden am Tag, 5 Tage die Woche geöffnet – von Sonntag 17:00 Uhr EST bis Freitag 16:00 Uhr EST – entsprechend den internationalen Marktzeiten.',
  'faq.general.q4': 'Ist meine Investition bei Ihnen sicher?',
  'faq.general.a4': 'Ja. Wir sind vollständig reguliert und lizensiert. Kundengelder sind segregiert und bei sicheren Bankkonten verwahrt; zusätzlich besteht umfassender Versicherungsschutz.',

  // Account
  'faq.account.q1': 'Wie eröffne ich ein Handelskonto?',
  'faq.account.a1': 'Online: Formular ausfüllen, erforderliche Ausweisdokumente bereitstellen und Ersteinzahlung leisten. Der Prozess dauert in der Regel 1–2 Werktage.',
  'faq.account.q2': 'Wie hoch ist die Mindesteinzahlung?',
  'faq.account.a2': 'Die Mindesteinzahlung beträgt 1.000 USD für ein Standardkonto. Premiumkonten mit höheren Mindesteinlagen bieten zusätzliche Vorteile.',
  'faq.account.q3': 'Kann ich mehrere Handelskonten haben?',
  'faq.account.a3': 'Ja, Sie können mehrere Konten mit unterschiedlichen Basiswährungen oder Kontotypen eröffnen – passend zu Ihren Strategien und Ihrem Risikomanagement.',
  'faq.account.q4': 'Wie verifiziere ich mein Konto?',
  'faq.account.a4': 'Benötigt werden ein amtlicher Ausweis (Reisepass oder Führerschein) und ein Adressnachweis (Versorger- oder Kontoauszug) der letzten 3 Monate.',

  // Trading
  'faq.trading.q1': 'Wie groß ist die minimale Handelsgröße?',
  'faq.trading.a1': 'In der Regel 0,01 Lot für die meisten Edelmetall-Instrumente – für flexible Positionsgrößen und Risikosteuerung.',
  'faq.trading.q2': 'Welchen Hebel bieten Sie?',
  'faq.trading.a2': 'Wettbewerbsfähigen Hebel bis zu 1:100 für den Edelmetallhandel – mit verantwortungsvollem Risikomanagement.',
  'faq.trading.q3': 'Fallen Handelsgebühren an?',
  'faq.trading.a3': 'Wir arbeiten mit Spreads ohne Kommission. Unsere Spreads sind wettbewerbsfähig und transparent – ohne versteckte Kosten.',
  'faq.trading.q4': 'Kann ich automatisierte Strategien nutzen?',
  'faq.trading.a4': 'Ja. Unsere MT5-Plattform unterstützt Expert Advisors (EAs) und automatisierte Strategien – eigene Algos oder bestehende Handelssysteme.',

  // Platform
  'faq.platform.q1': 'Welche Handelsplattformen unterstützen Sie?',
  'faq.platform.a1': 'Wir setzen primär auf MetaTrader 5 (MT5) – Desktop (Windows/Mac), Mobile (iOS/Android) und Web.',
  'faq.platform.q2': 'Ist MT5 kostenlos?',
  'faq.platform.a2': 'Ja. Der Download und die Nutzung sind kostenlos. Volle Funktionen, Charts, Indikatoren und Tools ohne Zusatzkosten.',
  'faq.platform.q3': 'Kann ich mobil handeln?',
  'faq.platform.a3': 'Absolut. Die MT5-Apps für iOS und Android bieten volle Trading-Funktionalität, Realtime-Charts, News und Kontoverwaltung.',
  'faq.platform.q4': 'Bieten Sie Demokonten an?',
  'faq.platform.a4': 'Ja. Kostenlose Demokonten mit virtuellem Kapital, um zu üben und die Plattform kennenzulernen.',

  // Deposits & Withdrawals
  'faq.deposits.q1': 'Welche Einzahlungsmethoden akzeptieren Sie?',
  'faq.deposits.a1': 'Banküberweisung, Kredit-/Debitkarten (Visa, MasterCard) und verschiedene E-Payment-Methoden – sicher und effizient.',
  'faq.deposits.q2': 'Wie lange dauern Einzahlungen?',
  'faq.deposits.a2': 'Karten meist sofort, Banküberweisungen 1–3 Werktage, E-Payments in der Regel innerhalb weniger Stunden.',
  'faq.deposits.q3': 'Gibt es Einzahlungsgebühren?',
  'faq.deposits.a3': 'Wir erheben für die meisten Methoden keine Gebühren. Ihre Bank/Zahlungsanbieter können eigene Gebühren verlangen.',
  'faq.deposits.q4': 'Wie hebe ich Gelder ab?',
  'faq.deposits.a4': 'Auszahlungen beantragen Sie im Kundenportal. Rückführung in der Regel auf die Einzahlungsquelle; Zeiten je nach Zahlungsmethode.',

  // Security
  'faq.security.q1': 'Wie schützen Sie meine persönlichen Daten?',
  'faq.security.a1': 'Bankenähnliche Verschlüsselung (SSL 256-Bit) für alle Übertragungen. Sichere Speicherung – keine Weitergabe ohne Zustimmung.',
  'faq.security.q2': 'Gibt es Zwei-Faktor-Authentifizierung?',
  'faq.security.a2': 'Ja, 2FA wird dringend empfohlen – zusätzlicher Schutz vor unbefugtem Zugriff.',
  'faq.security.q3': 'Was passiert, wenn ich mein Passwort vergesse?',
  'faq.security.a3': 'Passwort über „Passwort vergessen“ zurücksetzen – Sie erhalten per E-Mail einen sicheren Link.',
  'faq.security.q4': 'Wie stellen Sie faire Handelsbedingungen sicher?',
  'faq.security.a4': 'Transparente Preise mit Echtzeit-Daten, kein Dealing-Desk-Eingriff und strikte regulatorische Compliance für faire, ethische Bedingungen.',

  // Hero (extras)
  'hero.browseFAQ': 'FAQ durchsuchen',
  'hero.contactSupport': 'Support kontaktieren',

  // Contact CTA
  'contactCTA.phoneTitle': 'Telefon-Support',
  'contactCTA.phoneDesc': 'Sprechen Sie direkt mit unseren Spezialisten',
  'contactCTA.callNow': 'Jetzt anrufen',
  'contactCTA.emailTitle': 'E-Mail-Support',
  'contactCTA.emailDesc': 'Detaillierte Antworten in Schriftform',
  'contactCTA.sendMsg': 'Nachricht senden',
  'contactCTA.chatTitle': 'Live-Chat',
  'contactCTA.chatDesc': 'Sofort-Support per Chat',
  'contactCTA.available': 'Rund um die Uhr verfügbar',
  'contactCTA.startChat': 'Chat starten',
  'contactCTA.title': 'Brauchen Sie weitere Hilfe?',
  'contactCTA.subtitle': 'Unser Expertenteam ist 24/7 verfügbar und unterstützt Sie bei allen Fragen und Anliegen.',
  "androidDownload.title": "MetaTrader 5 herunterladen",
  "androidDownload.description": "Sie werden automatisch zu Google Play weitergeleitet. Wenn Google Play auf Ihrem Gerät nicht verfügbar ist, können Sie die APK direkt herunterladen.",
  "androidDownload.autoRedirect": "Weiterleitung zu Google Play in {{seconds}} Sekunden",
  "androidDownload.openGooglePlay": "Google Play öffnen",
  "androidDownload.downloadApk": "APK direkt herunterladen",
  "androidDownload.hint": "Wenn Google Play nicht geöffnet wird, tippen Sie bitte auf „APK direkt herunterladen“.",
  'windowsDownload.pageTitle': 'Windows MT5 herunterladen',
  'windowsDownload.pageDesc': 'Bitte wählen Sie die passende Installationsversion.',
  'windowsDownload.badge': 'Windows MT5 Download',
  'windowsDownload.title': 'Installationspaket auswählen',
  'windowsDownload.description': 'Bitte wählen Sie ein Windows-MT5-Installationspaket. Die Gold Label Smooth Stable Version wird für Nutzer in Festlandchina und Hongkong empfohlen. Sie können auch den offiziellen Installer verwenden.',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': 'Empfohlen für Windows-Nutzer in Festlandchina / Hongkong. Nutzer in anderen Regionen können diese Version ebenfalls verwenden, falls der offizielle Installer unpraktisch ist.',
  'windowsDownload.smoothButton': 'Gold Label Smooth Stable Version herunterladen',
  'windowsDownload.officialTitle': '2. Offizieller MetaQuotes-Installer',
  'windowsDownload.officialDesc': 'Ursprünglicher Download-Link. Windows-Nutzer in Festlandchina können gelegentlich Installationsprobleme haben; Nutzer in anderen Regionen sind nicht betroffen.',
  'windowsDownload.officialButton': 'Offiziellen Installer herunterladen',

  // Economic calendar explorer
  'calendar.hongKongTime': 'Hongkonger Zeit (GMT+8)',
  'calendar.previousDays': 'Vorherige 7 Tage',
  'calendar.nextDays': 'Nächste 7 Tage',
  'calendar.today': 'Heute',
  'calendar.jumpToDate': 'Zum Datum springen',
  'calendar.completeView': 'Vollständige Ansicht',
  'calendar.allDays': 'Alle 7 Tage',
  'calendar.events': 'Ereignisse',
  'calendar.impactAll': 'Alle Auswirkungen',
  'calendar.impactHigh': 'Hoch',
  'calendar.impactMedium': 'Mittel',
  'calendar.impactLow': 'Niedrig',
  'calendar.searchPlaceholder': 'Ereignis, Land oder Währung suchen',
  'calendar.eventsFound': 'Ereignisse angezeigt',
  'calendar.lastUpdated': 'Zuletzt aktualisiert',
  'calendar.loadError': 'Der Wirtschaftskalender ist vorübergehend nicht verfügbar.',
  'calendar.noEvents': 'Keine passenden Wirtschaftsereignisse gefunden.',
  'calendar.tryAnotherDate': 'Wählen Sie ein anderes Datum oder löschen Sie die Filter.',
  'calendar.time': 'Zeit',
  'calendar.impact': 'Auswirkung',
  'calendar.released': 'Veröffentlicht',
  'calendar.pending': 'Ausstehend',
  'calendar.disclaimer': 'Die Kalenderzeiten entsprechen der Hongkonger Zeit. Werte können revidiert werden und dienen nur zur Information.',
  'news.tab.newsDesc': 'Aktuelle Marktnachrichten, Goldanalysen und Bildungsinhalte',
  'news.tab.calendarDesc': 'Wichtige Wirtschaftsereignisse und Veröffentlichungen für umliegende Tage anzeigen',
  'news.autoRefresh': 'Nachrichten werden automatisch aktualisiert',

  'news.tabs.news': 'Nachrichten',
  'news.tabs.calendar': 'Wirtschaftskalender',

};

export default common;
